import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation, withRouterConfig } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngxs/store';
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions, themeBalham } from 'ag-grid-community';
import { AllEnterpriseModule, colorSchemeLightWarm } from 'ag-grid-enterprise';
import {
  DateTimeComponent,
  FILibConfig,
  MizuhoCommonTheme,
  provideFILibConfig, SessionTimeoutService,
  spinnerInterceptor,
  toastInterceptor
} from 'fi-ui-common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import packageJson from '../../package.json';
import { routes } from './app.routes';
import { httpInterceptor } from './interceptors/http-interceptor';
import {
  PaymentRankState
} from './pages/issuer/control-panel/payment-rank-management/payment-rank-store/payment-rank-state';
import { IssuerState } from './pages/issuer/issuer-store/issuer-state';
import { WorkspaceManagementState } from './shared/stores/workspace/workspace-management.state';
import { primengStyles } from '../styles/primeng-styles';

ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

provideGlobalGridOptions({
  theme: themeBalham.withPart(colorSchemeLightWarm).withParams({
    spacing: 3,
    columnBorder: { style: 'solid'},
  }),
  enableCellTextSelection: true,
  suppressMaintainUnsortedOrder: true,
  suppressDragLeaveHidesColumns: true,
  animateRows: false,
  tooltipShowDelay: 1000,
  multiSortKey: 'ctrl',
  components: { agDateInput: DateTimeComponent }
});

export const LIB_CONFIG: FILibConfig = {
  baseUrl: '',
  uiVersion: packageJson.version,
  spinner: {
    excludedUrls: [
      'service/potentialissuer',
      'service/bulk/summary',
      'service/history/filter/tenors',
      'service/single/secondaries',
      'service/bulk/secondaries',
      'service/issuer/bulkAvailability',
      'service/potentialIssuer/withSecondaries',
      'service/issuers/priced',
      'ui-settings/user/save',
      'ui-settings/get',
      '/currencies'
    ]
  },
  toast: {
    excludedStatuses: [401],
  },
  storage: {
    key: 'SyndicatePricerGlobal',
    version: 1
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    SessionTimeoutService,
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withRouterConfig({onSameUrlNavigation: 'reload'})),
    provideHttpClient(
      withInterceptors([httpInterceptor, spinnerInterceptor, toastInterceptor])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: {
          ...MizuhoCommonTheme,
          css: () => primengStyles
        },
        options: {
          darkModeSelector: 'none',
        }
      },
      ripple: true
    }),
    provideFILibConfig(LIB_CONFIG),
    provideStore([IssuerState, PaymentRankState, WorkspaceManagementState]),
  ]
};
